define.alias("ember-cli-string-helpers/helpers/w", "media/helpers/w");